import React, { Suspense, useEffect } from "react";
import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";

import "./index.css";

import ProductionScrollable, {
  ProductionErrorBoundary,
} from "./ProductionScrollable";
import PreviewScrollable, { PreviewErrorBoundary } from "./PreviewScrollable";
import { initDatadogScrollable } from "@labxchange/util-datadog";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
    },
  },
});

const extractProjectFromPath = () => {
  const path = window.location.pathname;
  const segments = path.split("/").filter(Boolean);
  return segments[segments.length - 1];
};

const isPreviewMode = () => {
  return window.location.pathname.includes("/preview-1");
};

const App = () => {
  // If the pathname does not include "scrollables", render the error page. 
  // See apps/scrollable/README.md for details.
  if (!window.location.pathname.includes("scrollables")) {
    return  (
      <div className="query-error">
        <div
            style={{
              color: "white",
              fontSize: "20px",
              padding: "20px",
              textAlign: "center",
            }}
        >
          <p
            style={{ color: "white", marginBottom: "15px", fontSize: "24px" }}
          >
            <strong>An error occurred.</strong>
          </p>
          <p style={{ color: "white", marginBottom: "15px" }}>
            Check console for details.
          </p>
        </div>
      </div>
    );
  }

  const query = new URLSearchParams(window.location.search);
  const lang = query.get("lng") || "en";

  useEffect(() => {
    initDatadogScrollable(extractProjectFromPath());
  }, []);

  return (
    <div className={["ar", "ur"].includes(lang) ? "rtl" : ""}>
      {isPreviewMode() ? (
        <PreviewScrollable lang={lang} />
      ) : (
        <ProductionScrollable lang={lang} />
      )}
    </div>
  );
};
const ErrorBoundary = isPreviewMode()
  ? PreviewErrorBoundary
  : ProductionErrorBoundary;
ReactDOM.render(
  <ErrorBoundary>
    <Suspense
      fallback={
        <div className="fallback-loading">
          <div className="loading-animation1">.</div>
          <div className="loading-animation2">.</div>
          <div className="loading-animation3">.</div>
        </div>
      }
    >
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Suspense>
  </ErrorBoundary>,
  document.getElementById("container")
);
